{
	"_comment": "This file is updated by the build process. Do not edit it manually.",
	"version": "1.70.5",
	"hash": "c1012533c8635abcb48194852d4e3d8eb6794498"
}
